import React, { useEffect, useState } from 'react';
import { useLocation  } from 'react-router-dom';
// import { NavLink } from 'react-router-dom';

import logo from '../Arkane-logo.webp'
import close from '../assets/images/63e0c727a8112ac3b1ad8126_x_icon.webp'
import menu from '../assets/images/63e0c727a8112a2da7ad8107_Burger-button.webp'


function Header() {
      const location = useLocation();
     const [activePage, setActivePage] = useState("");
         const [scrolled, setScrolled] = useState(false);
          const [isShow, setIsShow] = useState(false);
            const showMenu = () => {
    setIsShow(!isShow);
  };


  
  useEffect(() => {
    setActivePage(location.pathname);
  }, [location]);


        useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    

    window.addEventListener('scroll', handleScroll);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


    return (
        <header>
              <div className={`nav-container w-container ${scrolled ? 'stricky-fixed' : ''}`}>
            
                      <a href="/"  className="brand-nav w-nav-brand w--current" aria-label="home">
                          <img src={logo} loading="lazy" alt="Arkane Logo" height="30" className="logo" />
                      </a>
            
                      <div className={`nav-menu-wrapper ${isShow ? 'show' : ''}`} >
                          <nav role="navigation" className="nav-menu w-nav-menu">
                              <div className="nav-menu-shadow-overlay">
                                  <div className="close-button-wrap" onClick={showMenu}>
                                      <a href="/" className="logo-mobile w-nav-brand" aria-label="home">
                                          <img src={logo} loading="lazy" alt="Arkane Logo" height="24" className="image-2" />
                                      </a>
                                      <div className="close-menu-button w-nav-button">
                                          <img src={close}
                                              loading="lazy" alt="" className="nav-close-icon" />
                                      </div>
                                  </div>
                                  <a href="/" className={`nav-link w-nav-link ${activePage === "/" ? "active" : ""}`}>Home</a>
                                  <a href="/about-arkane" className={`nav-link w-nav-link ${activePage === "/about-arkane" ? "active" : ""}`}>About</a>
                                  <a href="/arkane-services" className={`nav-link w-nav-link ${activePage === "/arkane-services" ? "active" : ""}`}>Services</a>
                                  {/* <a href="/arkane-clients" className={`nav-link w-nav-link`}>Projects</a> */}
                                  <a href="/arkane-team" className={`nav-link w-nav-link ${activePage === "/arkane-team" ? "active" : ""}`}>Team</a>
                                  <a href="/arkane-career" className={`nav-link w-nav-link ${activePage === "/arkane-career" ? "active" : ""}`}>Career</a>
                                  <a href="/contact-arkane" className={`primary-button mobile-menu ${activePage === "/contact-arkane" ? "active" : ""}`}>Contact</a>
                              </div>
                          </nav>
                      </div>
            
                      <div className="buttons-wrap-nav">
                          {/* <div className="info-wrap hidden-header">
                              <div className="icon-info"></div><a href="tel:080-28282221" className="number">080-28282221</a>
                          </div> */}
                          <a href="/contact-arkane" className="primary-button hidden-tablet">Contact Us</a>
                      </div>
            
                      <div className="menu-button w-nav-button" onClick={showMenu}>
                          <img src={menu}
                              loading="lazy" alt="" height="16" />
                      </div>
                  </div>
        </header>
    )
}

export default Header;